import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { notify } from 'libs/common';
import { Window } from 'components/shared/window/window';
import { closeWindow } from 'store/actions/windows';
import { Button, Content, Item, Title, Value, ItemButtons } from './settingslimits.styled';

export const SettingsLimits = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const dispatch = useDispatch();
  const zones = useSelector((state) => state.boards.boards);
  // console.log('🚀 ~ SettingsLimits ~ zones:', zones);
  const [zonescnt, setZonescnt] = useState(zones);

  const changeZone = (event) => {
    let val = event.target.value;
    if (!val) {
      val = 0;
    }

    if (val > zones[event.target.name].maximum) {
      val = zones[event.target.name].maximum;
    }

    const name = event.target.name;

    const out = { ...zonescnt };
    out[name].regular = val;
    setZonescnt(out);
  };

  const close = () => {
    dispatch(closeWindow('settingslimitswindow'));
  };

  const save = (zoneId) => {
    const val = parseInt(zonescnt[zoneId].regular);
    const zoneMax = zones[zoneId].maximum;

    if (val > zoneMax) {
      notify(t('messages.Ошибка'), t('messages.Количество мест не может превышать ') + zoneMax);
      return;
    }

    const out = { zone_id: zoneId, count: val };

    // console.log('🚀 ~ save ~ out:', out);
    socket.call('set_zone_regular_places', out);
    notify(t('widgets.Постоянные клиенты'), t('widgets.Изменения для зоны ') + zoneId + t('widgets. сохранены'), 'success');
    // close();
  };

  const getItemsEl = () => {
    return Object.keys(zones).map((id) => {
      const zone = zones[id];
      const val = zonescnt[id].regular || '';
      if (val === undefined) {
        return (
          <Item>
            <Title>
              {zone.name}: {t(' не поддерживается')}
            </Title>
          </Item>
        );
      }
      return (
        <Item key={id}>
          <Title>{zone.name}</Title>
          <Value>
            <input type="number" name={id} value={val} onChange={changeZone} max={zone.maximum} min={0} />
          </Value>
          <ItemButtons>
            <Button onClick={() => save(id)}>{t('buttons.Сохранить')}</Button>
          </ItemButtons>
        </Item>
      );
    });
  };

  if (!zones || !Object.keys(zones).length) {
    return null;
  }

  const itemsEl = getItemsEl();

  const x = window.innerWidth / 2 - 162;

  return (
    <Window width="420px" {...data} defaultPosition={{ x, y: 40 }}>
      <Content>
        {itemsEl}

        {/* <Buttons>
          <Button onClick={close}>Отменить</Button>
        </Buttons> */}
      </Content>
    </Window>
  );
};
